module.exports = __webpack_public_path__ + "static/img/15.1ec56ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/15.png
// module id = i7oZ
// module chunks = 0